import React from 'react'
import { Link } from 'react-router'
import RaisedButton from 'material-ui/RaisedButton'
import ElectricalIcon from '../../../public/images/icons/electrical.svg'
import EssentialsIcon from '../../../public/images/icons/essential.svg'
import MechanicalIcon from '../../../public/images/icons/mechanical.svg'
import SoftwareIcon from '../../../public/images/icons/software.svg'

const _icons = {
  electrical: ElectricalIcon,
  essential: EssentialsIcon,
  mechanical: MechanicalIcon,
  software: SoftwareIcon
};

const IconColumn = ({config}) => {
  
    const IconCards = Object.keys(config).map((key, index) => {
      const {description, title} = config[key];
      return (
        <div  className="materials" key={index}>
          <hr className="hr-material"/>
          <Link to={`/materials/${key}`} key={key}>
          <div className="materials-grid">

            <div className="grid-cell u1of4">
              <img src={_icons[key]} alt={title} className="icon" />
            </div>

            <div className="grid-cell">
              <h4 className="material-title">{title.toUpperCase()}</h4>
              <p className="material-description">{description}</p>
            </div>

            <div className="grid-cell">
              <div className="material-buttons">
                  <RaisedButton
                    primary={true}
                    style={{minWidth: '200px', marginTop: '10px', marginBottom: '5px'}}
                    label="View Full Syllabus"
                    className="materials-view-button"
                  />
                <br />
                <RaisedButton
                  secondary={true}
                  style={{minWidth: '200px'}}
                  label="Sign Up for Updates"
                  className="materials-download-button"
                />
              </div>
            </div>
          </div>
          </Link>
        </div>
      );
    })

    return (
      <div>
        {IconCards}
      </div>
    );
}

export default IconColumn



// WEBPACK FOOTER //
// ./src/components/Materials/IconColumn.js